import React, { Component } from "react";
import { NAV_BAR_TITLE_ID } from "./components/navBar";

class AbstractPage extends Component {
  constructor(props) {
    super(props)

    this.title = "Abstract Page";
  }

  componentDidMount() {
    document.getElementById(NAV_BAR_TITLE_ID).innerHTML = this.title;
  }
}

export default AbstractPage;



// WEBPACK FOOTER //
// ./src/views/AbstractPage.js